<div
  class="relative grid size-12 place-items-center rounded-sm border-2 text-white"
  [class]="{
    'border-pink-500': speaker() === 'LEFT',
    'bg-pink-400': speaker() === 'LEFT',
    'border-blue-500': speaker() === 'RIGHT',
    'bg-blue-400': speaker() === 'RIGHT',
  }"
>
  <div
    class="absolute top-[50%] size-4 -translate-y-[50%] rounded-bl-sm border-b-2 border-l-2"
    [class]="{
      'rotate-45': speaker() === 'RIGHT',
      '-rotate-135': speaker() === 'LEFT',
      'border-pink-500': speaker() === 'LEFT',
      'bg-pink-400': speaker() === 'LEFT',
      'border-blue-500': speaker() === 'RIGHT',
      'bg-blue-400': speaker() === 'RIGHT',
      '-left-2.25': speaker() === 'RIGHT',
      '-right-2.25': speaker() === 'LEFT',
    }"
  ></div>

  @if (speaker() === 'RIGHT') {
    <i-pupil class="absolute size-8" />
  } @else {
    <i-tutor class="absolute size-8" />
  }
</div>
